import React from 'react';
import GoalCoachPanel from './GoalCoachPanel';

export default function SmartSuggestions({ goals }) {
  return <GoalCoachPanel goals={goals} />;
}
